import { render, staticRenderFns } from "./products-tab-pane-content.vue?vue&type=template&id=f57457fe&"
import script from "./products-tab-pane-content.vue?vue&type=script&lang=js&"
export * from "./products-tab-pane-content.vue?vue&type=script&lang=js&"
import style0 from "./products-tab-pane-content.vue?vue&type=style&index=0&id=f57457fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports